<template>
  <v-content>
    <v-container>
      <v-row v-show="loading">
        <v-container class="mt-12">
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-progress-circular
                :size="55"
                :width="4"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-row>
          </v-col>
        </v-container>
      </v-row>
      <list
        v-show="!loading"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        :can-user-delete="canUserDelete"
        :show-add-new="!isInternalPartner"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadDealers"
      >
        <template v-slot:select-headers>
          <filter-menu
            ref="filterMenu"
            :headers="headerOptions"
            :filters="filterOptions"
            :menu="filterMenu"
            :show-filter-options="true"
            location="account"
            @close="handleCloseFilterMenu"
            @update:headers="handleUpdateHeaders"
          ></filter-menu> </template
      ></list>
      <delete-dialog
        :dialog="deleteDialog"
        :item="itemName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
import FilterMenu from "@/components/general/FilterMenu.vue";
import restrictions from "../../utils/restrictions";

export default {
  components: {
    List,
    DeleteDialog,
    FilterMenu,
  },
  data: () => ({
    filterMenu: false,
    filterOptions: {
      title: "",
      items: [{ title: "", options: [{ text: "", value: "" }] }],
    },
    headerOptions: [],
    headers: [],
    data: [],
    sort: "name",
    title: "Dealers",
    response: null,
    loading: true,
    itemName: null,
    deleteDialog: false,
    canUserDelete: true,
  }),
  created() {
    this.setInitalData();
    this.loadDealers(this.$route.query);
  },
  computed: {
    isInternalPartner() {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    loadDealers(params) {
      !params && (params = {});

      this.loading = true;
      this.data = [];
      api.getDealerList(params).then((resp) => {
        this.setHeaders();
        this.response = resp.data;
        this.data = resp.data.results;
        this.title = this.isInternalPartner
          ? this.$t("users.dealers.account")
          : this.$t("users.dealers.partners");
        if (resp.data.results.length === 1 && this.isInternalPartner) {
          this.editFn(resp.data.results[0], { single: true });
          return;
        }
        this.loading = false;
      });
    },
    setInitalData() {
      this.headerOptions = [
        {
          text: this.$t("users.dealers.name"),
          align: "left",
          sortable: false,
          value: "name",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.brands"),
          align: "left",
          value: "brands",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.licence"),
          align: "left",
          value: "licence_type",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.users"),
          align: "left",
          value: "user_count",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.country"),
          align: "left",
          value: "country",
          canHide: true,
        },
        {
          text: this.$t("users.dealers.city"),
          align: "left",
          value: "city",
          canHide: true,
        },
      ];

      if (!restrictions.canUseCrmFeature("has_licencing_enabled")) {
        const index = this.headerOptions.findIndex((header) => {
          return header.value === "licence_type";
        });
        this.headerOptions.splice(index, 1);
      }

      this.title = this.$t("users.dealers.partners");
    },
    setHeaders() {
      if (this.isInternalPartner) {
        let index = this.headers.findIndex((header) => {
          return header.value === "brands";
        });

        if (index) {
          this.headers.splice(index, 1);
        }
      }
    },

    handleCloseFilterMenu(value) {
      this.filterMenu = value;
    },

    handleUpdateHeaders(headers, menu = true) {
      this.headers = this.headerOptions.filter((item) => {
        return headers.includes(item.value) || !item.canHide;
      });
      this.filterMenu = menu;
    },

    editFn(dealer, query) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerEdit",
          params: { id: dealer.uuid },
          query: { ...this.$route.query, ...query },
        });
      } else {
        this.$router.push({
          name: "dealerEdit",
          params: { id: dealer.uuid },
          query: { ...this.$route.query, ...query },
        });
      }
    },
    deleteFn(item) {
      this.deleteDialog = true;
      this.item = item;
      this.itemName = item.name;
    },
    remove(agreed) {
      if (agreed) {
        api.deleteDealer(this.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadDealers();
        });
      }
      this.deleteDialog = false;
    },
    previewFn(dealer) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerDetails",
          params: { id: dealer.uuid },
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "dealerDetails",
          params: { id: dealer.uuid },
          query: this.$route.query,
        });
      }
    },
    newFn(item) {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerNew",
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "dealerNew",
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
